/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const BarChartTwoFillIcon = /*#__PURE__*/ createSvgIcon(
  'BarChartTwoFillIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.99 12h-4v6h4v-6zM11.99 8h-4v10h4V8z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.96 2h4.05v16h-4.05V2zm1 1v14h2.05V3h-2.05z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default BarChartTwoFillIcon;
